import Request from "@/services/api/Request";

import { API_URL } from "@/constants";

export const routes = {
  global: `${API_URL}/search/json`,
  tracks: `${API_URL}/search/tracks`
};

export const request = new Request("search");

export default {
  global({ q = "" }) {
    return q ? request.get(routes.global, { q }) : Promise.resolve({});
  },
  tracks({ q = "" }) {
    return q ? request.get(routes.tracks, { q }) : Promise.resolve({});
  }
};
